import { alpha, Box, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { theme } from "src/assets/theme";
import TypingIndicator from "src/components/TypingIndicator";

interface Props {
  content?: string;
}

const AssistantMessage = ({ content }: Props) => {
  const [isTyping, setIsTyping] = useState<boolean>(true);

  useEffect(() => {
    if (content == null) {
      return;
    }

    const timer = setTimeout(() => setIsTyping(false), 1000);

    return () => clearTimeout(timer);
  }, [content]);

  if (isTyping || !content) {
    return <TypingIndicator />;
  }

  return (
    <Stack
      maxHeight={window.innerHeight - 32 - 90}
      minHeight={0}
      width={"100%"}
      alignSelf={"baseline"}
      p={2}
      gap={2}
      sx={{
        wordWrap: "break-word",
        borderRadius: "10px",
      }}
    >
      <Stack gap={2}>
        <Box
          sx={{
            px: 2,
            py: 1.5,
            bgcolor: "grey.100",
            borderRadius: 3,
            minWidth: "10%",
            maxWidth: "70%",
            width: "fit-content",
            animation: "fadeIn 0.3s ease-out",
            "@keyframes fadeIn": {
              from: { opacity: 0, transform: "translateY(4px)" },
              to: { opacity: 1, transform: "translateY(0)" },
            },
            boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.15)}`,
          }}
        >
          <Typography>{content}</Typography>
        </Box>
        <Typography variant="subtitle2">Vida - AI Agent</Typography>
      </Stack>
    </Stack>
  );
};

export default AssistantMessage;
